
import VLazyImage from 'v-lazy-image'
import config from '@/config'

export default {
  name: 'SectionAbout',

  components: {
    VLazyImage,
  },

  data() {
    return {
      members: config.members,
    }
  },
}
